import { useContext } from 'react';
import axios from 'axios';
import { ViewContext, AuthContext, ClassHelper } from 'components/lib';
import { GB, ES, TR } from 'country-flag-icons/react/1x1'
import i18n from 'i18next';
import Style from './locale.module.scss';

const flags = { en: GB, es: ES, tr: TR }

export function LocalePicker(props) {

    const viewContext = useContext(ViewContext);
    const authContext = useContext(AuthContext);

    const css = ClassHelper(Style, {

        picker: true,
        className: props.className

    });

    const languageOptions = [
        { value: 'en', label: 'English' },
        { value: 'es', label: 'Español - Spanish' },
        { value: 'tr', label: 'Türkçe - Turkish' },
    ]

    function show() {
        viewContext.modal.show({

            title: viewContext.t('global.locale.title'),
            method: 'PATCH',
            url: '/api/user',
            form: { 
                locale: {
                    label: viewContext.t('global.locale.form.language.label'),
                    type: 'select',
                    default: i18n.resolvedLanguage,
                    options: languageOptions
                }
            },
            buttonText: viewContext.t('global.locale.form.button'),
        }, (form) => {

            axios.defaults.headers.common['Accept-Language'] = form.locale.value;
            i18n.changeLanguage(form.locale.value);
            authContext.update({ locale: form.locale.value })

        })
    }

    const Flag = flags[i18n.resolvedLanguage];

    return (
        <div className={css} onClick={show}>
            <Flag />
            <p>{languageOptions.filter(option => option.value === i18n.resolvedLanguage)[0]?.label || null}</p>
        </div>
    )
}